import { NgModule } from "@angular/core";
import { UiModule } from "../../../lib/ui/ui.module";
import {
  PhoneNumberConfirmationReminderComponent
} from "./features/phone-number-confirmation-reminder/phone-number-confirmation-reminder.component";

@NgModule({
  imports: [UiModule],
  declarations: [PhoneNumberConfirmationReminderComponent],
  exports: [PhoneNumberConfirmationReminderComponent],
})
export class CustomerModule {}
